import { React, useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useFormik } from "formik";
import { Calendar } from 'primereact/calendar';
import { classNames } from 'primereact/utils';
import { InputTextarea } from 'primereact/inputtextarea';
import { attendanceApi, Util } from "../../services";
import { toast } from 'react-toastify';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Tooltip } from 'primereact/tooltip';
import { useLocation } from "react-router-dom";
import { userLeaveRecords } from '../../services/common/states';
import { workingHours } from "../../common/util/constants";
import { regularizationReason } from "../../common/util/constants";
import moment from "moment";

export default function AttendanceForm({ onCloseForm }) {
    const { search } = useLocation();
    const urlActions = new URLSearchParams(search).get("action");
    const urlDate = new URLSearchParams(search).get("date");
    const [showNewForm, setShowNewForm] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [checkedBox, setCheckedBox] = useState(false);
    const [weekOffCheckedBox, setWeekOffCheckedBox] = useState(false);
    const [compOffCheckedBox, setcompOffCheckedBox] = useState(false);
    const [startDate, setStartDate] = useState(Util.getMondayOfCurrentWeek(urlActions, urlDate));
    const [holidays, setHolidays] = useState([]);
    const [allRegions, setAllRegions] = useState([]);
    const [existingDateData, setExistingDateData] = useState([]);
    const [attendanceUpdate, setAttendanceUpdate] = useState(true);
    const [updateAttendanceId, setUpdateAttendanceId] = useState('');
    const [regOutDate, setRegOutDate] = useState(null);

    const currentDate = new Date();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const dateInTimeZone = new Date(currentDate.toLocaleString('en-US', { timeZone: timeZone }));
    const tomorrowDate = new Date(dateInTimeZone);
    tomorrowDate.setDate(tomorrowDate.getDate() + 1);

    useEffect(() => {
        getAllAttendanceHolidays()
        setStartDate(Util.getMondayOfCurrentWeek(urlActions, urlDate));
    }, [urlActions]);

    /* get all holidays start*/
    const getAllAttendanceHolidays = () => {
        attendanceApi.getAllAttendanceHolidays().then((resp) => {
            setHolidays(resp.data.h_data);
            //fetch unique region from array
            let regions = []
            resp.data.h_data?.map((item) => {
                regions.push(item.region)
            })
            let uniqueRegion = Array.from(new Set(regions))
            setAllRegions(uniqueRegion)
        })
    }
    /* get all holidays end*/
    const formik = useFormik({
        initialValues: {
            inTime: '',
            outTime: '',
            date: null,
            outDate: null,
            reason: null,
            attachment: null,
            location: ''
        },
        validate: (data) => {
            let errors = {};

            if (!data.date) {
                errors.date = 'Date is required';
            }
            if (!checkedBox && !weekOffCheckedBox && !compOffCheckedBox) {
                if (!data.inTime) {
                    errors.inTime = 'In Time is required.';
                }
                if (!data.outTime) {
                    errors.outTime = 'Out Time is required.';
                }
                if (!data.reason) {
                    errors.reason = 'Reason is required';
                }
                if (!data.location) {
                    errors.location = 'Location is required';
                }
            }
            return errors;
        },
        onSubmit: (data) => {
            createMissingAttendance(data);
        }
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const attendanceForm = () => {
        setShowNewForm(true);
    };

    const closeForm = () => {
        formik.resetForm();
        setErrorMsg("");
        setShowNewForm(false);
        onCloseForm();
    };

    /*Fetching Holiday List Start*/
    const dateTemplate = (date, e) => {
        let calenderDay = date.day;
        let calenderMonth = (date.month) + 1;
        let calenderYear = date.year;
        var calenderDateString = calenderYear + '-' + (calenderMonth <= 9 ? '0' + calenderMonth : calenderMonth) + '-' + (calenderDay <= 9 ? '0' + calenderDay : calenderDay);
        let holiday = {
            indHolDateList: [],
            indHolNameList: [],
            ausHolDateList: [],
            ausHolNameList: [],
            ukHolDateList: [],
            ukHolNameList: [],
            usaDateList: [],
            usaNameList: [],
            singDateList: [],
            singNameList: [],
            canDateList: [],
            canNameList: [],
            phlDateList: [],
            phlNameList: [],
            irlDateList: [],
            irlNameList: []
        }
        e?.map((x) => {
            switch (x.region) {
                case 'IND':
                    holiday.indHolDateList.push(x?.date);
                    holiday.indHolNameList.push(x?.name);
                    break;
                case 'AUS':
                    holiday.ausHolDateList.push(x?.date);
                    holiday.ausHolNameList.push(x?.name);
                    break;
                case 'UK':
                    holiday.ukHolDateList.push(x?.date);
                    holiday.ukHolNameList.push(x?.name);
                    break;
                case 'USA':
                    holiday.usaDateList.push(x?.date);
                    holiday.usaNameList.push(x?.name);
                    break;
                case 'SIN':
                    holiday.singDateList.push(x?.date);
                    holiday.singNameList.push(x?.name);
                    break;
                case 'PHL':
                    holiday.phlDateList.push(x?.date);
                    holiday.phlNameList.push(x?.name);
                    break;
                case 'CAN':
                    holiday.canDateList.push(x?.date);
                    holiday.canNameList.push(x?.name);
                    break;
                case 'IRL':
                    holiday.irlDateList.push(x?.date);
                    holiday.irlNameList.push(x?.name);
                    break;
                default:
                    holiday.indHolDateList.push(x?.date);
                    holiday.indHolNameList.push(x?.name);
            }
        });

        if (holiday.indHolDateList.includes(calenderDateString)) {
            let index = holiday.indHolDateList.findIndex(x => x == calenderDateString);
            return (
                <>
                    <span className={"disabled-button_" + date.day} style={{ backgroundColor: '#38bbe6', color: '#000000', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: calenderDay <= 9 ? '9px' : '5px' }}>{date.day}
                        <Tooltip target={".disabled-button_" + date.day}>{holiday.indHolNameList[index]}</Tooltip>
                    </span>
                </>
            )
        }
        if (holiday.ausHolDateList.includes(calenderDateString)) {
            let index = holiday.ausHolDateList.findIndex(x => x == calenderDateString);
            return (
                <>
                    <span className={"disabled-button_" + date.day} style={{ backgroundColor: '#dfe700', color: '#000000', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: calenderDay <= 9 ? '9px' : '5px' }}>{date.day}
                        <Tooltip target={".disabled-button_" + date.day}>{holiday.ausHolNameList[index]}</Tooltip>
                    </span>
                </>
            )
        }
        if (holiday.ukHolDateList.includes(calenderDateString)) {
            let index = holiday.ukHolDateList.findIndex(x => x == calenderDateString);
            return (
                <>
                    <span className={"disabled-button_" + date.day} style={{ backgroundColor: '#86c807', color: '#000000', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: calenderDay <= 9 ? '9px' : '5px' }}>{date.day}
                        <Tooltip target={".disabled-button_" + date.day}>{holiday.ukHolNameList[index]}</Tooltip>
                    </span>
                </>
            )
        }
        if (holiday.usaDateList.includes(calenderDateString)) {
            let index = holiday.usaDateList.findIndex(x => x == calenderDateString);
            return (
                <>
                    <span className={"disabled-button_" + date.day} style={{ backgroundColor: '#e929e9', color: '#000000', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: calenderDay <= 9 ? '9px' : '5px' }}>{date.day}
                        <Tooltip target={".disabled-button_" + date.day}>{holiday.usaNameList[index]}</Tooltip>
                    </span>
                </>
            )
        }
        if (holiday.singDateList.includes(calenderDateString)) {
            let index = holiday.singDateList.findIndex(x => x == calenderDateString);
            return (
                <>
                    <span className={"disabled-button_" + date.day} style={{ backgroundColor: '#a48fef', color: '#000000', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: calenderDay <= 9 ? '9px' : '5px' }}>{date.day}
                        <Tooltip target={".disabled-button_" + date.day}>{holiday.singNameList[index]}</Tooltip>
                    </span>
                </>
            )
        }
        if (holiday.phlDateList.includes(calenderDateString)) {
            let index = holiday.phlDateList.findIndex(x => x == calenderDateString);
            return (
                <>
                    <span className={"disabled-button_" + date.day} style={{ backgroundColor: '#ffa000', color: '#000000', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: calenderDay <= 9 ? '9px' : '5px' }}>{date.day}
                        <Tooltip target={".disabled-button_" + date.day}>{holiday.phlNameList[index]}</Tooltip>
                    </span>
                </>
            )
        }
        if (holiday.canDateList.includes(calenderDateString)) {
            let index = holiday.canDateList.findIndex(x => x == calenderDateString);
            return (
                <>
                    <span className={"disabled-button_" + date.day} style={{ backgroundColor: '#ff6363', color: '#000000', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: calenderDay <= 9 ? '9px' : '5px' }}>{date.day}
                        <Tooltip target={".disabled-button_" + date.day}>{holiday.canNameList[index]}</Tooltip>
                    </span>
                </>
            )
        }
        if (holiday.irlDateList.includes(calenderDateString)) {
            let index = holiday.irlDateList.findIndex(x => x == calenderDateString);
            return (
                <>
                    <span className={"disabled-button_" + date.day} style={{ backgroundColor: '#d3acc4', color: '#000000', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: calenderDay <= 9 ? '9px' : '5px' }}>{date.day}
                        <Tooltip target={".disabled-button_" + date.day}>{holiday.irlNameList[index]}</Tooltip>
                    </span>
                </>
            )
        }
        else {
            return (<span>{date.day}</span>)
        }
    }
    /*Fetching Holiday List End*/

    const createMissingAttendance = (data) => {
        const date = new Date(data.date);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        let reqDate = Util.dateConverterForAttendance(data.date);
        let reqOutDate = Util.dateConverterForAttendance(data.outDate);
        let reqInTime = Util.getTimeWithTimezone(data.inTime);
        let reqOutTime = Util.getTimeWithTimezone(data.outTime);

        if (existingDateData?.date === moment(new Date()).format("YYYY-MM-DD") && existingDateData?.status === 0) {
            toast.error("Can't regularize today's attendance before markout for the day!")
        } else {
            if (attendanceUpdate) {
                let obj = {
                    date: Util.dateConverterForAttendance(data.date),
                    outDate: Util.dateConverterForAttendance(data.outDate),
                    inTime: weekOffCheckedBox ? date : checkedBox ? date : compOffCheckedBox ? date : Util.convertTZ(reqDate, reqInTime),
                    outTime: weekOffCheckedBox ? date : checkedBox ? date : compOffCheckedBox ? date : Util.convertTZ(reqOutDate, reqOutTime),
                    reason: weekOffCheckedBox ? 'Week Off' : checkedBox ? 'Client Holiday' : compOffCheckedBox ? 'Comp Off' : data.reason,
                    innTime: Util.convertTZ(reqDate, reqInTime),
                    outtTime: Util.convertTZ(reqDate, reqOutTime),
                    location: weekOffCheckedBox ? 'WO' : checkedBox ? 'CH' : compOffCheckedBox ? 'CO' : data.location.code,
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    isClientHoliday: checkedBox ? true : false,
                    isWeekOff: weekOffCheckedBox ? true : false,
                    isRegularize: checkedBox ? false : true,
                    isCompOff: compOffCheckedBox ? true : false
                };
                const workingTimeCalcDiff = Util.attendanceHrdDiff(obj.innTime, obj.outTime);
                if (Util.convertHoursIntoMin(workingTimeCalcDiff) >= Util.convertHoursIntoMin(workingHours.HOURS) || Util.convertHoursIntoMin(workingTimeCalcDiff) < 0) {
                    toast.error("Working hrs should not greater than 14:00 hrs! or should not less than 00 hrs!")
                } else {
                    attendanceApi.createAttendanceRequest(obj).then(resp => {
                        if (resp.data.success === true) {
                            userLeaveRecords.next(resp.data.data);
                            toast.success(resp.data.message)
                        } else {
                            toast.error(resp.data.error)
                        }
                        closeForm();
                    });
                }

            } else {
                let obj = {
                    id: updateAttendanceId,
                    date: Util.dateConverterForAttendance(data.date),
                    outDate: Util.dateConverterForAttendance(data.outDate),
                    inTime: weekOffCheckedBox ? date : checkedBox ? date : compOffCheckedBox ? date : Util.convertTZ(reqDate, reqInTime),
                    outTime: weekOffCheckedBox ? date : checkedBox ? date : compOffCheckedBox ? date : Util.convertTZ(reqOutDate, reqOutTime),
                    comments: weekOffCheckedBox ? 'Week Off' : checkedBox ? 'Client Holiday' : compOffCheckedBox ? 'Comp Off' : data.reason,
                    innTime: Util.convertTZ(reqDate, reqInTime),
                    outtTime: Util.convertTZ(reqDate, reqOutTime),
                    location: weekOffCheckedBox ? 'WO' : checkedBox ? 'CH' : compOffCheckedBox ? 'CO' : data.location.code,
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                    isClientHoliday: checkedBox ? true : false,
                    isWeekOff: weekOffCheckedBox ? true : false,
                    isRegularize: checkedBox ? false : true,
                    isCompOff: compOffCheckedBox ? true : false
                };
                const workingTimeCalcDiff = Util.attendanceHrdDiff(obj.innTime, obj.outTime);
                if (Util.convertHoursIntoMin(workingTimeCalcDiff) >= Util.convertHoursIntoMin(workingHours.HOURS) || Util.convertHoursIntoMin(workingTimeCalcDiff) < 0) {
                    toast.error("Working hrs should not greater than 14:00 hrs! or should not less than 00 hrs!")
                } else {
                    attendanceApi.updateMissingAttendance(obj).then(
                        (resp) => {
                            if (resp) {
                                toast.success("Attendance Updated!");
                            }
                            closeForm();
                        },
                        (err) => {
                            toast.error("Unable to update missing attendance");
                        }
                    );
                }
            }
        }
    }

    const officeOrHome = [
        { label: 'Office', code: 'WFO' },
        { label: 'Home', code: 'WFH' },
    ];
    const yourDropdownOptionsArray = [
        { label: regularizationReason.MARKOUT_FORGOT, value: regularizationReason.MARKOUT_FORGOT },
        { label: regularizationReason.REFILL_ATTENDANCE, value: regularizationReason.REFILL_ATTENDANCE },
        // Add more options as needed
    ];


    const handleClick = (e) => {
        formik.handleChange(e);
        formik.setFieldValue('date', e.value);
        let updatedOutDate = Util.addDays(e.value, 2);
        setRegOutDate(updatedOutDate);
        var dateObj = {
            date: Util.dateConverterForAttendance(e.value),
        };
        try {
            attendanceApi.existingAttendanceCheck(dateObj).then(
                (resp) => {
                    if (resp.data.success) {
                        setExistingDateData(resp.data.data);
                        if (resp?.data?.data) {
                            setAttendanceUpdate(false);
                            setUpdateAttendanceId(resp?.data?.data?.id)
                            formik.setFieldValue('outDate', resp?.data?.data?.outDate !== null ? new Date(resp?.data?.data?.outDate) : e.value);
                            formik.setFieldValue('inTime', new Date(resp?.data?.data?.inTime));
                            formik.setFieldValue('outTime', resp?.data?.data?.outTime !== null ? new Date(resp?.data?.data?.outTime) : '');
                        } else {
                            setAttendanceUpdate(true)
                            formik.setFieldValue('outDate', e.value);
                            formik.setFieldValue('inTime', '');
                            formik.setFieldValue('outTime', '');
                        }
                        toast.success(resp.data.message)
                    } else {
                        toast.error(resp.data.error)
                    }
                },
                (err) => {
                    toast.error(err);
                }
            );
        } catch (error) {
        }
    }


    const changeHolidayCheckbox = (e) => {
        formik.setFieldValue('inTime', '');
        formik.setFieldValue('outTime', '');
        setCheckedBox(e.checked);
    }
    const changeWeekOffCheckbox = (e) => {
        formik.setFieldValue('inTime', '');
        formik.setFieldValue('outTime', '');
        setWeekOffCheckedBox(e.checked);
    }
    const changeCompOffCheckbox = (e) => {
        formik.setFieldValue('inTime', '');
        formik.setFieldValue('outTime', '');
        setcompOffCheckedBox(e.checked)
    }

    return (
        <>
            <Button className="p-button-rounded" label="Request Attendance" icon="pi pi-external-link" onClick={() => attendanceForm()} />
            <Dialog header="Request for Regularization" visible={showNewForm} className="attendance_regularization" onHide={() => setShowNewForm(false)}
            >
                <form onSubmit={formik.handleSubmit} className="p-fluid p-grid">
                    <div className="grid mt-1">
                        <div className="p-field col-6">
                            <span>
                                <label htmlFor="date" style={{ marginRight: '2px' }}>Date</label>
                                <level> <i className="custom-region-btn pi pi-info-circle"></i> </level>
                                <Tooltip target=".custom-region-btn">
                                    {
                                        allRegions?.map((item, i) => {
                                            if (item === "IND") return <p style={{ fontWeight: 'bold' }} key={"IND" + i}>{item} : <span style={{ backgroundColor: '#38bbe6', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "AUS") return <p style={{ fontWeight: 'bold' }} key={"AUS" + i}>{item} : <span style={{ backgroundColor: '#dfe700', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "UK") return <p style={{ fontWeight: 'bold' }} key={"UK" + i}>{item} : <span style={{ backgroundColor: '#86c807', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "USA") return <p style={{ fontWeight: 'bold' }} key={"USA" + i}>{item} : <span style={{ backgroundColor: '#e929e9', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "SIN") return <p style={{ fontWeight: 'bold' }} key={"SIN" + i}>{item} : <span style={{ backgroundColor: '#a48fef', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "CAN") return <p style={{ fontWeight: 'bold' }} key={"CAN" + i}>{item} : <span style={{ backgroundColor: '#ff6363', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "PHL") return <p style={{ fontWeight: 'bold' }} key={"PHL" + i}>{item} : <span style={{ backgroundColor: '#ffa000', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "IRL") return <p style={{ fontWeight: 'bold' }} key={"IRL" + i}>{item} : <span style={{ backgroundColor: '#d3acc4', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                        })
                                    }
                                </Tooltip>
                                <Calendar id="date" maxDate={tomorrowDate} name="date" value={formik.values.date} onChange={handleClick} placeholder="Date" showIcon dateFormat="dd/mm/yy" dateTemplate={(e) => dateTemplate(e, holidays)} className={classNames({ "p-invalid": isFormFieldValid("date") })} />
                            </span>
                            {getFormErrorMessage('date')}

                        </div>
                        <div className="p-field col-6">
                            <span>
                                <label htmlFor="date" style={{ marginRight: '2px' }}> Out Date</label>
                                <level> <i className="custom-region-btn pi pi-info-circle"></i> </level>
                                <Tooltip target=".custom-region-btn">
                                    {
                                        allRegions?.map((item, i) => {
                                            if (item === "IND") return <p style={{ fontWeight: 'bold' }} key={"IND" + i}>{item} : <span style={{ backgroundColor: '#38bbe6', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "AUS") return <p style={{ fontWeight: 'bold' }} key={"AUS" + i}>{item} : <span style={{ backgroundColor: '#dfe700', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "UK") return <p style={{ fontWeight: 'bold' }} key={"UK" + i}>{item} : <span style={{ backgroundColor: '#86c807', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "USA") return <p style={{ fontWeight: 'bold' }} key={"USA" + i}>{item} : <span style={{ backgroundColor: '#e929e9', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "SIN") return <p style={{ fontWeight: 'bold' }} key={"SIN" + i}>{item} : <span style={{ backgroundColor: '#a48fef', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "CAN") return <p style={{ fontWeight: 'bold' }} key={"CAN" + i}>{item} : <span style={{ backgroundColor: '#ff6363', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "PHL") return <p style={{ fontWeight: 'bold' }} key={"PHL" + i}>{item} : <span style={{ backgroundColor: '#ffa000', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                            if (item === "IRL") return <p style={{ fontWeight: 'bold' }} key={"IRL" + i}>{item} : <span style={{ backgroundColor: '#d3acc4', color: '#ffffff', fontWeight: 'bold', borderRadius: '50%', width: '2em', height: '2em', lineHeight: '2em', paddingLeft: '20px', marginLeft: '5px' }}></span></p>
                                        })
                                    }
                                </Tooltip>

                                <Calendar id="outDate" maxDate={regOutDate} minDate={formik.values.date} disabled={!formik.values.date} name="outDate" value={formik.values.outDate} onChange={formik.handleChange} placeholder="Date" showIcon dateFormat="dd/mm/yy" dateTemplate={(e) => dateTemplate(e, holidays)} className={classNames({ "p-invalid": isFormFieldValid("date") })} />
                            </span>
                        </div>
                    </div>
                    <div className='mb-3 checkbox_block'>
                        <span className='regular_checkbox'> 
                            <Checkbox
                                id="leave"
                                name=""
                                onChange={e => changeHolidayCheckbox(e)} checked={checkedBox}
                                disabled={weekOffCheckedBox || compOffCheckedBox}
                            />
                            <span style={{ marginLeft: '5px' }}>Client Holiday</span>
                        </span>
                        <span className='regular_checkbox'>
                            <Checkbox
                                id="leave"
                                name=""
                                onChange={e => changeWeekOffCheckbox(e)} checked={weekOffCheckedBox}
                                disabled={checkedBox || compOffCheckedBox}
                            />
                            <span style={{ marginLeft: '5px' }}>Week Off</span>
                        </span>
                        <span className='regular_checkbox'>
                            <Checkbox
                                id="leave"
                                name=""
                                onChange={e => changeCompOffCheckbox(e)} checked={compOffCheckedBox}
                                disabled={checkedBox || weekOffCheckedBox}
                            />
                            <span style={{ marginLeft: '5px' }}>Comp Off</span>
                        </span>
                    </div>

                    <div className="grid mt-1">
                        <div className="p-field col-6">
                            <span>
                                <label htmlFor="inTime">In Time</label>
                                <Calendar keyfilter="time" id="inTime" name="inTime" value={formik.values.inTime} timeOnly hourFormat="24" showSeconds disabled={checkedBox || weekOffCheckedBox || compOffCheckedBox} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("inTime") })} />
                            </span>
                            {getFormErrorMessage('inTime')}
                        </div>

                        <div className="p-field col-6">
                            <span>
                                <label htmlFor="outTime">Out Time</label>
                                <Calendar keyfilter="int" id="outTime" name="outTime" value={formik.values.outTime} timeOnly hourFormat="24" showSeconds disabled={checkedBox || weekOffCheckedBox || compOffCheckedBox || !formik.values.inTime} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("outTime") })}
                                />
                            </span>
                            {getFormErrorMessage('outTime')}
                        </div>
                        <div className="p-field col-12">
                            <label htmlFor="date">Location</label>
                            <span>
                                <Dropdown disabled={checkedBox || weekOffCheckedBox || compOffCheckedBox} options={officeOrHome} name="location" value={formik.values.location} onChange={formik.handleChange} placeholder="Select your Location" />
                            </span>
                            {getFormErrorMessage('location')}
                        </div>
                    </div>
                    <div className="p-field">
                        <span>
                            <label htmlFor="reason">Reason</label>
                            <Dropdown
                                id="reason"
                                name="reason"
                                disabled={checkedBox || weekOffCheckedBox || compOffCheckedBox}
                                value={formik.values.reason}
                                options={yourDropdownOptionsArray}
                                onChange={formik.handleChange}
                                className={classNames({ "p-invalid": isFormFieldValid("reason") })}
                                placeholder="Select a reason"
                            />
                        </span>
                        {getFormErrorMessage('reason')}
                    </div>
            {/* <div className="p-field">
                        <span>
                            <label htmlFor="reason">Reason</label>
                            <InputTextarea id="reason" name="reason" autoResize disabled={checkedBox || weekOffCheckedBox || compOffCheckedBox} onKeyPress={Util.charIntWhithoutSpace} value={formik.values.reason} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("reason") })} />
                        </span>
                        {getFormErrorMessage('reason')}
                    </div> */}
            <div className='pt-3'>
                        <div className='text-right'>
                            <div>
                                <Button type="button" label="Cancel" className="p-button-rounded p-default" onClick={() => closeForm()} />
                                <Button type="submit" label="Submit" className="p-button-rounded" />
                            </div> 
                        </div>
                    </div>
                </form>
            </Dialog>
        </>
    )
}